import React from "react";
import { CheckCircle } from "lucide-react";
import { useTheme } from "../../../context/ThemeContext";

const points = [
  "We are a performance-driven digital marketing agency.",
  "We help businesses generate high-quality leads & sales.",
  "5+ years experience in SEO, Ads & Branding strategies.",
  "Data-driven approach with measurable results."
];

function Aboutdm() {
    const {theme} = useTheme();
    const img = theme==="light"?'lightdm.png':"darkdm.png";
  return (
    <section className="relative py-16 px-6 bg-[#f8f8f8] dark:bg-[#050505] overflow-hidden">

     
      {/* BACKGROUND EFFECTS */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

        {/* LEFT CONTENT */}
        <div>

          <p className="text-orange-500 font-medium mb-3">
            About Our Agency
          </p>

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white leading-tight">
            We Build Brands That Grow {" "}
             <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-500 bg-clip-text text-transparent">
           Faster Online  
            </span>
           
          </h2>

          <p className="text-gray-600 dark:text-gray-400 mt-5 text-lg">
            We are a full-service digital marketing agency focused on helping
            businesses scale through SEO, paid ads, branding, and performance marketing.
          </p>

          {/* Points */}
          <div className="mt-6 space-y-4">
            {points.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <CheckCircle className="w-5 h-5text-primary mt-1" />
                <p className="text-gray-700 dark:text-gray-300">
                  {item}
                </p>
              </div>
            ))}
          </div>

          {/* Mission Vision */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">

            <div className="p-5 rounded-xl bg-white/70 dark:bg-[#111]/70 border border-gray-100 dark:border-gray-800 backdrop-blur-md">
              <h4 className="font-semibold text-gray-900 dark:text-white">
                Our Mission
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                To help businesses grow digitally with smart marketing strategies.
              </p>
            </div>

            <div className="p-5 rounded-xl bg-white/70 dark:bg-[#111]/70 border border-gray-100 dark:border-gray-800 backdrop-blur-md">
              <h4 className="font-semibold text-gray-900 dark:text-white">
                Our Vision
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                To become a leading performance marketing agency globally.
              </p>
            </div>

          </div>

        </div>

        {/* RIGHT IMAGE SIDE */}
        <div className="relative">

          {/* Main Image Card */}
          <div className="rounded-xl">

            <img
              src={img}
              alt="Digital Marketing Agency"
              className="w-full  object-contain"
            />

          </div>

          {/* Floating Card */}
          <div className="absolute -bottom-6 -left-6 bg-white dark:bg-[#111] p-5 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-800">

            <p className="text-2xl font-bold text-primary">40+</p>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Successful Clients
            </p>

          </div>

        </div>

      </div>
    </section>
  );
}

export default Aboutdm;